// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-modal{text-align:center}.add-modal .modal-sm.modal-dialog-centered{padding-top:0!important;max-width:100px!important}.add-modal .modal-sm.modal-dialog-centered .modal-body{padding:20px!important}.add-modal .modal-dialog{margin-left:auto;margin-right:auto}.add-modal .modal-dialog-centered{padding-top:0!important}.add-modal .header-class{padding:10px!important}.add-modal .header-class h5{margin-top:0!important}.add-modal .header-class .close{z-index:100!important}", ""]);
// Exports
module.exports = exports;
